// Import utilities
import { builderFetch } from '@automator/builder/utils';
import { html } from 'lit';

// Import global utils
import { isDefined } from '@automator/shared/utils/is-defined';
import { confirm } from '@automator/shared/utils/confirm';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __ } from '@wordpress/i18n';

/**
 * Set the requires user selector flag.
 *
 * @param {Boolean} requiresUserSelector Whether or not the recipe requires a user selector.
 * @return {Promise} The apiFetch promise
 */
const setRequiresUserSelector = async ( requiresUserSelector ) => {
	// Event name
	const eventName = 'uap/builder/core/user-selector/set-requires-user-selector';

	// If the item is not define, stop here
	if ( ! isDefined( requiresUserSelector ) ) {
		throw new Error( `setRequiresUserSelector: requiresUserSelector can't be empty` );
	}

	// If the user is trying to remove the user selector, we need to confirm it.
	if ( ! requiresUserSelector ) {
		await confirm( {
			content: html`
				<uo-alert type="warning">
					${ escapeHTML( __( 'Removing the user selector may result in unexpected behavior if any actions or tokens require user data.', 'uncanny-automator' ) ) }
				</uo-alert>
			`
		} );
	}

	// Set the user selector
	return builderFetch( {
		eventName: eventName,
		endpoint: 'set_recipe_requires_user',
		method: 'POST',
		data: {
			recipePostID: UncannyAutomator._recipe.recipe_id,
			requiresUser: requiresUserSelector,
		},
		snackbar: {
			loading: escapeHTML( __( 'Removing user selector', 'uncanny-automator' ) ),
			success: escapeHTML( __( 'User selector removed successfully', 'uncanny-automator' ) ),
		}
	} ).then( response => {
		// Check if the call was successful
		if ( response.success ) {
			// Send custom event to the document
			document.dispatchEvent( new CustomEvent( eventName, {
				detail: {
					requiresUserSelector: requiresUserSelector
				}
			} ) );
		}

		return response;
	} );
}

export default setRequiresUserSelector;

